import React from 'react';
import styles from './Spinner.module.css';

export const Spinner: React.FC = () => {
    return (
        <div className={styles.spinnerContainer}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 66 66"
                className={styles.spinner}
            >
                <circle
                    cx="33"
                    cy="33"
                    r="30"
                    fill="none"
                    className={styles.spinnerPath}
                ></circle>
            </svg>
            <p className={styles.spinnerText}>Loading</p>
        </div>
    );
};
